import { memo, ReactNode, use } from 'react';
import { Participant } from 'livekit-client';
import { useParticipantMetadata } from 'useCase/participant/useParticipantMetadata';
import { ListItemAvatarImage } from './view';

export interface IAvatarProps {
    participant: Participant;
    name: string;
    placeholder: ReactNode;
}

export const ParticipantListAvatar = memo(({ participant, name, placeholder }: IAvatarProps) => {
    const { getAvatarFromMetadata } = useParticipantMetadata();
    const result = getAvatarFromMetadata(participant.metadata);
    const avatar = typeof result === 'string' ? result : use(result);
    return avatar ? <ListItemAvatarImage src={avatar} alt={name} /> : <>{placeholder}</>;
});
